import { Box, Skeleton, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { orderStatsMessages } from "./messages";

interface OrderStatsCardsProps {
  totalOrders: number | undefined;
  fulfilledOrders: number | undefined;
  unfulfilledOrders: number | undefined;
  loading: boolean;
}

interface StatCardProps {
  title: string;
  value: number | undefined;
  loading: boolean;
  testId: string;
}

const StatCard = ({ title, value, loading, testId }: StatCardProps) => (
  <Box
    borderWidth={1}
    borderStyle="solid"
    borderColor="default1"
    borderRadius={3}
    paddingX={4}
    paddingY={4}
    display="flex"
    flexDirection="column"
    gap={1}
    data-test-id={testId}
  >
    <Text size={2} color="default2">
      {title}
    </Text>
    <Text size={8} fontWeight="bold">
      {loading || value === undefined ? <Skeleton __width="60px" /> : value.toLocaleString()}
    </Text>
  </Box>
);

export const OrderStatsCards = ({
  totalOrders,
  fulfilledOrders,
  unfulfilledOrders,
  loading,
}: OrderStatsCardsProps) => {
  const intl = useIntl();

  return (
    <Box display="grid" __gridTemplateColumns="repeat(3, 1fr)" gap={3} paddingX={6} paddingY={3}>
      <StatCard
        title={intl.formatMessage(orderStatsMessages.totalOrders)}
        value={totalOrders}
        loading={loading}
        testId="order-stats-total"
      />
      <StatCard
        title={intl.formatMessage(orderStatsMessages.fulfilled)}
        value={fulfilledOrders}
        loading={loading}
        testId="order-stats-fulfilled"
      />
      <StatCard
        title={intl.formatMessage(orderStatsMessages.unfulfilled)}
        value={unfulfilledOrders}
        loading={loading}
        testId="order-stats-unfulfilled"
      />
    </Box>
  );
};
